import { StyleSheet } from "react-native";
import { theme } from "../../theme";
export const styles = StyleSheet.create({
    touchableOpacity: {
        borderRadius: theme.spacing.xsmall,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: theme.spacing.xlarge3,
        paddingVertical: theme.spacing.xsmall,
        paddingHorizontal: theme.spacing.small,
    },
    slim: {
        minHeight: theme.spacing.xlarge,
    },
    heading: {
        marginHorizontal: theme.spacing.xsmall,
        fontFamily: "ProximaSemiBold",
        flex: 1,
    },
    button: {
        borderRadius: theme.spacing.xlarge4,
        width: theme.spacing.xlarge2,
        height: theme.spacing.xlarge2,
        alignItems: "center",
        justifyContent: "center",
    },
    slimButton: {
        width: theme.spacing.medium,
        height: theme.spacing.medium,
    },
    brand: {
        backgroundColor: theme.colors.brand.base,
    },
    accent: {
        backgroundColor: theme.colors.accent.base,
    },
    warning: {
        backgroundColor: theme.colors.warning.base,
    },
    light: {
        backgroundColor: theme.colors.light.base,
    },
    negative: {
        backgroundColor: theme.colors.negative.base,
    },
    dark: {
        backgroundColor: theme.colors.dark.base,
    },
    contentContainer: {
        padding: theme.spacing.small,
        marginHorizontal: theme.spacing.xsmall,
        borderBottomLeftRadius: theme.spacing.xsmall,
        borderBottomRightRadius: theme.spacing.xsmall,
    },
});
//# sourceMappingURL=Accordion.styles.js.map